var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#25BCBD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22C31.0609 22 32.0783 21.5786 32.8284 20.8285C33.5786 20.0783 34 19.0609 34 18V15.3334C34 14.2725 33.5786 13.2551 32.8284 12.5049C32.0783 11.7548 31.0609 11.3334 30 11.3334H14C12.9391 11.3334 11.9217 11.7548 11.1716 12.5049C10.4214 13.2551 10 14.2725 10 15.3334V18C10 19.0609 10.4214 20.0783 11.1716 20.8285C11.9217 21.5786 12.9391 22 14 22M30 22H14M30 22C31.0609 22 32.0783 22.4215 32.8284 23.1716C33.5786 23.9218 34 24.9392 34 26V28.6667C34 29.7276 33.5786 30.745 32.8284 31.4951C32.0783 32.2453 31.0609 32.6667 30 32.6667H14C12.9391 32.6667 11.9217 32.2453 11.1716 31.4951C10.4214 30.745 10 29.7276 10 28.6667V26C10 24.9392 10.4214 23.9218 11.1716 23.1716C11.9217 22.4215 12.9391 22 14 22M15.3333 16.6667V16.68M15.3333 27.3334V27.3467",
    stroke: "#25BCBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/Services1.8f0ab68b4e512a74091289a6d95089a5.svg";
export { ForwardRef as ReactComponent };